/**
 * A workspace's address: its slug, which is Impa's, and the one label of its host,
 * `<slug>.<ROOT_DOMAIN>` (Impa docs/PLATFORM_CONVENTIONS.md, rule 2). Lower-case letters, digits and
 * hyphens, starting and ending with a letter or digit, at most 40.
 */
export const WORKSPACE_ADDRESS = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

/**
 * A person's role in a workspace, decided on every request once Impa admits them, as Steer's and Sustain's are: an
 * Administrator is whoever Impa names Admin of Link; a User of Link is an Editor where Link holds that (People gives
 * it), and a Viewer otherwise, who reads the directory and changes nothing. A role in the organisation is never a
 * role here.
 */
export const WORKSPACE_ROLES = ["administrator", "editor", "viewer"] as const;
export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];

/** Whether someone changes the directory: Administrators and Editors do, and a Viewer doesn't. */
export function edits(role: WorkspaceRole): boolean {
  return role !== "viewer";
}

/** Link's own roles a User may hold, by key, as People gives them: Editor. */
export const LINK_ROLES = ["editor"] as const;
